export const Messages = {
  generic: 'Lo sentimos, ocurrió un error inesperado.',
  timeout: 'Ocurrió un error en el servidor, el tiempo de espera se ha agotado.',
  timeoutError: 'Parece que esto está demorando demasiado, verifica tu conexión a internet e intentálo nuevamente.',
  conexionError: 'Ocurrió un error de conexion. No se pudo establecer la conexión con el servidor.',
  serviceUnavailable: 'Por el momento nuestro sitio se encuentra en mantenimiento, pero no te preocupes no tardaremos mucho.',
  backOnline: 'A Comer Club se encuentra nuevamente operando, vuelva a iniciar sesión para salir del Modo Offline'
};


export const ChangePassMessage = {
  messagechangepass: 'Te hemos enviado instrucciones para restablecer tu contraseña, verifica tu correo electrónico.',
  messageerrorchange: 'Ha ocurrido un error o el email no existe en nuestros registros, por favor intenta nuevamente.',
};

export const MemberMessages = {
  updatePasswordSuccess: 'Has actualizado tu contraseña exitosamente.',
  updatePasswordError: 'Ha ocurrido un error al modificar tu contraseña.',
};
